import { clearFormRuntimeStateForSlot } from '@/common/composables/useFormStates'
import { clearFormShellVisibilityRuntime } from '@/common/utils/formShellVisibilityCleanup'
import { resolveFormSchemaIdFromPageEntry } from '@/common/utils/resolvePageIdentity'

export function clearDialogSlotRuntimeState(
  slotId: string,
  pageEntry?: Record<string, unknown> | null,
): void {
  const slot = String(slotId ?? '').trim()
  if (!slot) return

  clearFormRuntimeStateForSlot(slot)

  const registryFormIds: string[] = []
  if (pageEntry && typeof pageEntry === 'object') {
    const schemaId = resolveFormSchemaIdFromPageEntry(pageEntry, pageEntry.status)
    if (schemaId != null && String(schemaId).trim() !== '') {
      registryFormIds.push(String(schemaId).trim())
    }
  }

  clearFormShellVisibilityRuntime({ slotId: slot, registryFormIds })
}
